import React from 'react';
import MainSection from './MainSection/MainSection';
import Navbar from './Navbar/Navbar';

const Header = () => {
    const styles = {
        backgroundColor:'#F9FAFD'
    }
    return (
        <div style={styles}>
           <Navbar></Navbar>
           <MainSection></MainSection> 
        </div>
    );
};

export default Header;